import axiosApi from "shared/api/axiosApi";
import { CorporateIssuanceResponse, GetCorporateIssuanceParams, GetIndividualIssuanceParams, IndividualIssuanceResponse } from "../types/applicationsTypes";
import { AxiosResponse } from "axios";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";

export const applicationsAPI = {
  getIndividualIssuanceByMarathonId: async (data: GetIndividualIssuanceParams): Promise<AxiosResponse<IndividualIssuanceResponse>> => {
    const distanceAgeId = String(data?.distanceAgeId).split(" ");
    const distanceParts = String(data?.distanceId).split(" ");
    const distanceId = distanceParts[1];
    return await axiosApi.get(
      `/applications/marathon/${data?.marathonId}/individualIssuance`,
      {
        params: {
          startKitIssuanceType: data?.startKitIssuanceType,
          paymentMethod: data?.paymentMethod,
          startKitEnum: data?.startKitEnum,
          corporateClientId: data?.corporateClientId,
          country: data?.country,
          status: data?.status,
          searchTerm: data?.searchTerm,
          distanceAgeId: distanceAgeId[distanceAgeId.length - 1],
          distanceId: distanceId,
          gender: data?.gender,
          isPwd: data?.isPwd,
          page: data?.page,
          pageSize: data?.pageSize,
        },
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      },
    );
  },
  getCorporateIssuanceByMarathonId: async (data: GetCorporateIssuanceParams): Promise<AxiosResponse<CorporateIssuanceResponse>> => {
    const distanceAgeId = String(data?.distanceAgeId).split(" ");
    const distanceParts = String(data?.distanceId).split(" ");
    const distanceId = distanceParts[1];
    return await axiosApi.get(
      `/applications/marathon/${data?.marathonId}/corporateIssuance/${data?.corporateClientId}`,
      {
        params: {
          startKitIssuanceType: data?.startKitIssuanceType,
          paymentMethod: data?.paymentMethod,
          startKitEnum: data?.startKitEnum,
          corporateClientIdQuery: data?.corporateClientIdQuery,
          country: data?.country,
          status: data?.status,
          searchTerm: data?.searchTerm,
          distanceAgeId: distanceAgeId[distanceAgeId.length - 1],
          distanceId: distanceId,
          gender: data?.gender,
          isPwd: data?.isPwd,
          page: data?.page,
          pageSize: data?.pageSize,
        },
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      },
    );
  },
}